<script lang="ts">
	import { AdvancedCard, Select, type SelectOptionPropsType } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { format } from 'src/services/i18n';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, status: VCInterfaceStatus;

	let value: string = '';
	let waitForResponse: boolean = false;
	let valueBeforeSend: string = null;

	const titles = status.config?.meta?.ui?.titles || [];
	const options: SelectOptionPropsType[] = (status.config?.options || []).map((i) => {
		return {
			title: titles[i] || i,
			value: i,
		};
	});

	$: if (status) {
		value =
			valueBeforeSend !== null
				? valueBeforeSend
				: (status?.rawValue ?? status.config?.default_value ?? '');
		if (!waitForResponse && valueBeforeSend !== null && value == valueBeforeSend) {
			valueBeforeSend = null;
		}
	}

	const saveOption = async (value: number) => {
		if (waitForResponse) return;
		waitForResponse = true;
		const res: SettingRequest = await gen2Request(device, 'Enum.set', {
			id: status.id,
			value,
		});
		if (!res?.isok) {
			onSettingsResponse(res, device);
		}
		waitForResponse = false;
	};
</script>

<AdvancedCard title={translateTemplateTitle(status.name)} class="mb-s">
	<Select
		aria-label={$format('select_template_option', { default: 'Select Template Option' })}
		class="width-full"
		slot="main"
		value={options.find((i) => i.value == value) || options[0]}
		{options}
		icon={null}
		on:change={(e) => {
			saveOption(e.detail['value']);
		}}
		id="select-vc1vkwf"
	/>
</AdvancedCard>
